var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Video",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-video","viewBox":"0 0 45 34"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M0 0h45.003v33.75H0V0zm.75 33h43.503V.75H.75V33zm31.625-22.021v13.042l-5.338-3.166v1.248c0 1.253-.993 2.272-2.223 2.272h-8.967c-1.23 0-2.222-1.02-2.222-2.272v-9.206c0-1.253.993-2.272 2.222-2.272h8.968c1.228.003 2.217 1.022 2.217 2.272v1.248l5.343-3.166zm-6.093 4.482v-2.564c0-.841-.66-1.52-1.468-1.522h-8.967c-.81 0-1.472.68-1.472 1.522v9.206c0 .843.661 1.522 1.472 1.522h8.967c.811 0 1.473-.68 1.473-1.522v-2.565l5.338 3.166V12.295l-5.343 3.166z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/video.svg